import React, { useEffect, useState } from "react";
import ContactInjectWrapper from "../Contact/ContactInjectWrapper";
import { fetchStandardLayoutContent } from "../../Service/restapi/profileService";
import ContractContactInfo from "../Contact/ContractContactInfo";
import { useLingui } from "@lingui/react";
import {
  getDocumentTranslator,
  translateGeneratedDocumentText,
} from "../Document/documentLanguage";

const ContractParties = ({ contract, resourceId }) => {
  const [standardLayoutContent, setStandardLayoutContent] = useState(undefined);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, contract.language);
  const translatedTitle = translateGeneratedDocumentText(contract.title, t);

  useEffect(() => {
    fetchStandardLayoutContent(resourceId).then((resp) => {
      if (resp.ok) {
        resp.json().then(setStandardLayoutContent);
      }
    });
  }, [resourceId]);

  let styles = {
    container: {
      marginBottom: 20,
    },
    contacts: {
      display: "flex",
      justifyContent: "space-between",
    },
  };

  return (
    <div style={styles.container}>
      <div style={{ textAlign: "center", fontSize: 22 }} dangerouslySetInnerHTML={{ __html:  `${translatedTitle == null ? `${t("contractLabel")} ` : translatedTitle + ' '} ${contract.number ? `${t("documentNumberPrefix")} ` + contract.number : ""}`}}>
      </div>
      <div
        className={"description"}
        style={{ textAlign: "center", color: "#000000" }}
      >
        {t("between")}
      </div>
      <div style={styles.contacts}>
        <div style={{ width: 300 }}>
          <ContactInjectWrapper
            contactId={contract.customerId}
            resourceId={resourceId}
          >
            <ContractContactInfo
              withPartner
              isCustomer
              language={contract.language}
              translator={t}
              contractPartyDescription={
                standardLayoutContent
                  ? translateGeneratedDocumentText(
                      standardLayoutContent.contractPartyEmployerDescription,
                      t
                    )
                  : t("organizerLabel")
              }
            />
          </ContactInjectWrapper>
        </div>
        <div
          className={"description"}
          style={{ color: "#000000", alignSelf: "center" }}
        >
          {t("and")}
        </div>
        <div style={{ width: 300, textAlign: "right" }}>
          <ContactInjectWrapper
            contactId={contract.contactId}
            resourceId={resourceId}
          >
            <ContractContactInfo
              isCustomer={false}
              language={contract.language}
              translator={t}
              contractPartyDescription={
                standardLayoutContent
                  ? translateGeneratedDocumentText(
                      standardLayoutContent.contractPartyEmployeeDescription,
                      t
                    )
                  : t("serviceProviderLabel")
              }
            />
          </ContactInjectWrapper>
        </div>
      </div>
    </div>
  );
};

export default ContractParties;
